module.exports = __webpack_public_path__ + "img/page-01.95678b82.jpg";